import React, { memo } from 'react';

function Pause({ color = '#335B70', ...props }) {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 19H10V5H6V19ZM14 5V19H18V5H14Z"
                fill={color}
            />
        </svg>
    );
}

export default memo(Pause);
